// components/DeleteModal.jsx

const DeleteModal = ({ isOpen, title, message, onConfirm, onCancel }) => {
  if (!isOpen) return null

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40">
      <div className="bg-white py-10 px-20 rounded-md shadow-md max-w-md w-[80%]">
        <h2 className="text-center w-auto text-xl font-bold text-[#3E6BE0] mb-4">
          {title}
        </h2>
        <p className="text-center w-auto text-black-700 mb-6">{message}</p>
        <div className="flex justify-between gap-4">
          <button
            onClick={onCancel}
            className="px-4 py-2 bg-gray-300 text-gray-700 rounded-lg hover:bg-gray-400"
          >
            Cancel
          </button>
          <button
            onClick={onConfirm}
            className="px-4 py-2 bg-red-500 text-white rounded-lg hover:bg-red-600"
          >
            Delete
          </button>
        </div>
      </div>
    </div>
  )
}

export default DeleteModal
